<template>
    <div v-route-title="data?data.penalty.docTitle:'公司行政处罚信息'">
        <div class="yq-penalty-details" v-if="data">
            <div class="yq-penalty-title">{{data.penalty.docTitle}}</div>
            <table class="yq-penalty-table">
                <tr>
                    <td class="yq-penalty-table-head" width="100">名称</td>
                    <td class="yq-penalty-table-value" width="547">{{data.penalty.docTitle}}</td>
                    <td class="yq-penalty-table-head" width="100">文号</td>
                    <td class="yq-penalty-table-value">{{data.penalty.docNo}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head">处罚机构</td>
                    <td class="yq-penalty-table-value">{{data.penalty.mechanism}}</td>
                    <td class="yq-penalty-table-head">处罚类型</td>
                    <td class="yq-penalty-table-value">{{data.penalty.types?data.penalty.types.join('、'):''}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head">来源站点</td>
                    <td class="yq-penalty-table-value">{{data.penalty.docSite}}</td>
                    <td class="yq-penalty-table-head">来源栏目</td>
                    <td class="yq-penalty-table-value">{{data.penalty.docChannel}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head">处罚公司</td>
                    <td class="yq-penalty-table-value">
                        {{data.penalty.targetCompanies?data.penalty.targetCompanies.map(item=>item.name).join('、'):''}}
                    </td>
                    <td class="yq-penalty-table-head">处罚人</td>
                    <td class="yq-penalty-table-value">
                        {{data.penalty.targetPersons?data.penalty.targetPersons.map(item=>item.name+(item.company?('('+item.company.name+(item.position||'')+')'):'')).join('、'):''}}
                    </td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head">相关公司</td>
                    <td class="yq-penalty-table-value">
                        {{data.penalty.relatedCompanies?data.penalty.relatedCompanies.map(item=>item.name).join('、'):''}}
                    </td>
                    <td class="yq-penalty-table-head">处罚日期</td>
                    <td class="yq-penalty-table-value">
                        <pretty-date-time :value="data.penalty.penaltyDate" format="YYYY-MM-DD"></pretty-date-time>
                    </td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head">违规行为</td>
                    <td class="yq-penalty-table-value" colspan="3">{{data.penalty.irregularities}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head">处罚措施</td>
                    <td class="yq-penalty-table-value" colspan="3">{{data.penalty.penalties}}</td>
                </tr>
            </table>
            <div class="yq-penalty-foot">
                <a v-if="data.penalty.docUrl" class="yq-penalty-link" :href="data.penalty.docUrl" target="_blank">查看原文</a>
                <a v-else-if="data.sourceRecord&&data.sourceRecord.entryUrl" class="yq-penalty-link" :href="data.sourceRecord.entryUrl" target="_blank">查看原文</a>
            </div>
        </div>
    </div>
</template>

<script>
    import companyMonitorService from '../service/company_monitor'

    export default {
        name: "Penalty",
        props: {
            id: String
        },
        data(){
            return {
                data: null
            }
        },
        created(){
            companyMonitorService.getPenalty(this.id).then(response=>{
                this.data = response.data
            })
        }
    }
</script>

<style scoped>

</style>
